
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectReference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectReference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectReference"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projectReference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serviceProviderId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apartmentsAdded"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"externalId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedTimestamp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedByUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userName"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectCopyChanges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projectId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oldHeating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oldElevator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oldMainService"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oldInfrastructure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newHeating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newElevator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newMainService"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newInfrastructure"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProjectId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesContactUserName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfGProperties"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfLProperties"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfCompletedLProperties"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfCompletedGProperties"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editOptions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingsCreated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projectDownloaded"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfNonEditableBuildings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"treeNodesCreated"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":924}};
    doc.loc.source = {"body":"query GetProjectQuery($projectReference: String!) {\n  project(projectReference: $projectReference) {\n    id\n    projectReference\n    status\n    serviceProviderId\n    apartmentsAdded\n    customer {\n      name\n      id\n      externalId\n    }\n    lastUpdate {\n      lastUpdatedTimestamp\n      lastUpdatedByUser {\n        firstName\n        lastName\n        userName\n      }\n    }\n    projectCopyChanges {\n      id\n      projectId\n      oldHeating\n      oldElevator\n      oldMainService\n      oldInfrastructure\n      newHeating\n      newElevator\n      newMainService\n      newInfrastructure\n    }\n    parentProjectId\n    type\n    createdAt\n    salesContactUserName\n    numberOfGProperties\n    numberOfLProperties\n    numberOfCompletedLProperties\n    numberOfCompletedGProperties\n    editOptions {\n      buildingsCreated\n      editable\n      projectDownloaded\n      numberOfNonEditableBuildings\n      treeNodesCreated\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetProjectQuery"] = oneQuery(doc, "GetProjectQuery");
        
